import { BorderRadiusTokens, ColorTokens, FontSizeTokens, SizeTypeTokens, TagTypeTokens, } from '@voltmoney/schema';
export const tagTypeTokensMap = {
    [TagTypeTokens.DEFAULT]: {
        fontSize: FontSizeTokens.XXS,
        labelColor: ColorTokens.Grey_500,
        bgColor: ColorTokens.White,
        borderRadius: BorderRadiusTokens.BR4,
        padding: {
            horizontal: SizeTypeTokens.MD,
            vertical: SizeTypeTokens.SM,
        },
    },
    [TagTypeTokens.SECONDARY]: {
        fontSize: FontSizeTokens.XXS,
        labelColor: ColorTokens.Grey_100,
        bgColor: ColorTokens.Black_20,
        borderRadius: BorderRadiusTokens.BR4,
        padding: {
            horizontal: SizeTypeTokens.MD,
            vertical: SizeTypeTokens.SM,
        },
    },
    [TagTypeTokens.GRADIENT]: {
        fontSize: FontSizeTokens.XS,
        labelColor: ColorTokens.Grey_500,
        bgColor: ColorTokens.Grey_50,
        borderRadius: BorderRadiusTokens.BR4,
        padding: {
            horizontal: SizeTypeTokens.MD,
            vertical: SizeTypeTokens.SM,
        },
    },
    [TagTypeTokens.PRIMARY]: {
        fontSize: FontSizeTokens.XS,
        labelColor: ColorTokens.Grey_Charcoal,
        bgColor: ColorTokens.White,
        borderRadius: BorderRadiusTokens.BR4,
        padding: {
            horizontal: SizeTypeTokens.MD,
            vertical: SizeTypeTokens.SM,
        },
    },
};
